import { createContext, useContext, useEffect, useState } from "react";
import adminApi from "../lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vita_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    adminApi
      .get("/me")
      .then((r) => setAdmin(r.data))
      .catch(() => localStorage.removeItem("vita_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/login", { email, password });
    localStorage.setItem("vita_admin_token", r.data.token);
    setAdmin(r.data.admin);
    return r.data.admin;
  };

  const logout = () => {
    localStorage.removeItem("vita_admin_token");
    setAdmin(null);
  };

  const refresh = async () => {
    const r = await adminApi.get("/me");
    setAdmin(r.data);
    return r.data;
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return ctx;
}
